import Phone from './../models/Phone';
import Base from './Base';

export default class Phones extends Base {
    get models() {
        const collection = this.data.map(item => new Phone(item));
        collection.collection = this;

        return collection;
    }

    updateCallForwarding(number) {
        if (!(number instanceof Phone)) {
            number = new Phone(number);
        }

        return this.models.map(item => {
            if (item.id === number.id) {
                return number;
            } else {
                return item;
            }
        });
    }
}
